<template>
	<div>

		<div id="abonnement">
			<InvoiceInformation v-if="!step" v-on:completed="completed()">
				<h1 slot="headline">
					<span v-if="product == 1">{{$t('invoice-info.top.headline-screening')}}</span>
					<span v-else-if="product == 2">{{$t('invoice-info.top.headline-contract')}}</span>
					<span v-else-if="product == 3">{{$t('invoice-info.top.headline-monthly')}}</span>
					<span v-else-if="product == 4">{{$t('invoice-info.top.headline-annual')}}</span>
				</h1>
			</InvoiceInformation>
		</div>

		<template v-if="step == 'confirm'">
			<ConfirmOrder :product="product" v-model="orderId" v-on:next="goToPayment" :params="params" />
		</template>

		<template v-if="step == 'payment'">
			<div class="order-view">
				<h2 style="margin: 0px">{{ $t('order.payment.headline') }}</h2>
				<p style="margin-bottom: 30px;">
					{{ $t('order.payment.description') }}
				</p>

				<div class="content">
					<CreditCardList
						:select="true"
						v-model="creditCardId"
						v-on:terminalopened="terminalOpened"
						v-on:terminalclosed="terminalClosed" />
					<button v-if="!terminal_open" :disabled="!creditCardId || saving" v-on:click="complete()" class="purple margin-top">{{ $t('checkout.paynow.label') }}</button>
				</div>
			</div>
		</template>

	</div>
</template>

<script>
	import Vue from 'vue';

	import {mapGetters} from 'vuex';
	import ConfirmOrder from './Checkout/ConfirmOrder.vue';
	import CreditCardList from './Checkout/CreditCardList.vue';
	import InvoiceInformation from './Checkout/InvoiceInformation.vue';

	export default {
		props: [
			'product',
			'params'
		],
		computed: {
			...mapGetters([
				'getToken'
			])
		},
		components: {
			ConfirmOrder,
			CreditCardList,
			InvoiceInformation
		},
		data: () => ({
			saving: false,
			step: '',
			creditCardId: 0,
			orderId: false,
			show_checkout: false,
			terminal_open: false
		}),
		methods: {
			terminalOpened() {
				this.terminal_open = true;
			},
			terminalClosed() {
				this.terminal_open = false;
			},
			completed() {
				this.step = 'confirm';
			},
			goToPayment(data) {

					this.step = 'payment';
			},
			complete() {
				Vue.api.post('/order/' + this.orderId + '/confirm', {
					credit_card: this.creditCardId
				}, {
					before: () => this.saving = true,
					always: () => this.saving = false,
					callback: () => this.$emit('completed')
				});
			}
		}
	}
</script>
